SET_PAYMENT_METHODS_PROCESSING